import { Loading } from '@/components/loading/Loading';

import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { PageTitle } from '../../utils/Title';
import { useErrorHandler } from 'react-error-boundary';
import { useAuthentication } from '@/services/authentication/useAuthProvider';

export const Redirect: FC = () => {
  const onRedirect = useAuthentication(state => state.onRedirect);
  const handleError = useErrorHandler();
  const navigate = useNavigate();

  useEffect(() => {
    void (async () => {
      try {
        const path = await onRedirect();
        if (path && path !== '/auth/redirect' && path !== '/auth/signout' && path !== '/auth/signin') {
          navigate(path);
          return;
        }

        navigate('/');
      } catch (e) {
        console.error(e);
        handleError(e);
      }
    })();
  }, [navigate, onRedirect, handleError]);

  return (
    <>
      <PageTitle>Loading...</PageTitle>
      <Loading className="h-screen" />
    </>
  );
};
